import { Box, FormControl, FormHelperText, MenuItem, OutlinedInput, Select, SelectChangeEvent, Stack, Typography, useMediaQuery } from '@mui/material';
import { FunctionComponent } from 'react';
import gaiaTheme from '../../../../root-components/theme';
import { IRecieveEmailQuestionniare } from '../../shared-services/email-questionnaire/email-questionnaire.model';

export const EmaiLCampaignEmployeeDaysWorking: FunctionComponent<{
  formik: any,
  isDemonstrationPage: boolean,
  isTest: boolean,
  emailQuestionnaireDetails?: IRecieveEmailQuestionniare,
  includeProjects?: boolean,
}> = ({
  formik,
  isDemonstrationPage,
  isTest,
  emailQuestionnaireDetails,
  includeProjects
}) => {

    const isMobileModeSm = useMediaQuery(gaiaTheme.breakpoints.down('sm'));

    return (
      <Box>
        <Stack display='flex' alignItems={isMobileModeSm ? 'flex-start' : 'center'} flexDirection={isMobileModeSm ? 'column' : 'row'} justifyContent='start' sx={{ mt: 4, }}>
          <Typography variant='subtitle1' sx={{ color: 'text.primary', width: isMobileModeSm ? '100%' : '50%', minWidth: '400px' }}>Average number of days commuting per week?</Typography>
          <FormControl fullWidth variant='outlined'>
            <OutlinedInput
              id='numberCommutingDays'
              name='numberCommutingDays'
              type='number'
              fullWidth
              size='small'
              inputProps={{ min: 0, max: 7, step: 1 }}
              value={formik.values.numberCommutingDays}
              onChange={formik.handleChange}
              error={formik.touched.numberCommutingDays && Boolean(formik.errors.numberCommutingDays)}
            ></OutlinedInput>
            {formik.touched.numberCommutingDays && formik.errors.numberCommutingDays &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                {formik.errors.numberCommutingDays ? <div>{formik.errors.numberCommutingDays as string}</div> : null}
              </FormHelperText>
            }
          </FormControl>
        </Stack>
        <Stack display='flex' alignItems={isMobileModeSm ? 'flex-start' : 'center'} flexDirection={isMobileModeSm ? 'column' : 'row'} justifyContent='start' sx={{ mt: 2 }}>
          <Typography variant='subtitle1' sx={{ color: 'text.primary', width: isMobileModeSm ? '100%' : '50%', minWidth: '400px' }}>Average number of days working from home per week?</Typography>
          <FormControl fullWidth variant='outlined'>
            <OutlinedInput
              id='numberHomeWorkingDays'
              name='numberHomeWorkingDays'
              type='number'
              size='small'
              fullWidth
              inputProps={{ min: 1, max: 7, step: 1 }}
              value={formik.values.numberHomeWorkingDays}
              onChange={formik.handleChange}
              error={formik.touched.numberHomeWorkingDays && Boolean(formik.errors.numberHomeWorkingDays)}
            ></OutlinedInput>
            {formik.touched.numberHomeWorkingDays && formik.errors.numberHomeWorkingDays &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                {formik.errors.numberHomeWorkingDays ? <div>{formik.errors.numberHomeWorkingDays as string}</div> : null}
              </FormHelperText>
            }
          </FormControl>
        </Stack>
        {!(isDemonstrationPage || isTest) && emailQuestionnaireDetails && <Stack display='flex' alignItems={isMobileModeSm ? 'flex-start' : 'center'} flexDirection={isMobileModeSm ? 'column' : 'row'} justifyContent='start' sx={{ mt: 2, mb: emailQuestionnaireDetails.includeProjects ? 0 : 4 }}>
          <Typography variant='subtitle1' sx={{ color: 'text.primary', width: isMobileModeSm ? '100%' : '50%', minWidth: '400px' }}>Location of work</Typography>
          <FormControl fullWidth variant='outlined'>
            <Select
              size='small'
              id='locationId' name='locationId'
              value={formik.values.locationId}
              onChange={(e: SelectChangeEvent<string>) => {
                const value = e.target.value;
                formik.setFieldValue('locationId', value);
              }}
              error={formik.touched.locationId && Boolean(formik.errors.locationId)}
              fullWidth>
              {emailQuestionnaireDetails.locations.sort((a, b) => a.friendlyName.localeCompare(b.friendlyName)).map((location, index) => (
                <MenuItem key={index}
                  value={location.id}>{location.friendlyName}</MenuItem>
              ))}
            </Select>
            {formik.touched.locationId && formik.errors.locationId &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                {formik.errors.locationId ? <div>{formik.errors.locationId as string}</div> : null}
              </FormHelperText>
            }
          </FormControl>
        </Stack>}
        {!(isDemonstrationPage || isTest) && emailQuestionnaireDetails && emailQuestionnaireDetails.includeProjects && <Stack display='flex' alignItems={isMobileModeSm ? 'flex-start' : 'center'} flexDirection={isMobileModeSm ? 'column' : 'row'} justifyContent='start' sx={{ mt: 2, mb: 4 }}>
          <Typography variant='subtitle1' sx={{ color: 'text.primary', width: isMobileModeSm ? '100%' : '50%', minWidth: '400px' }}>Project</Typography>
          <FormControl fullWidth variant='outlined'>
            <Select
              size='small'
              id='projectId' name='projectId'
              value={formik.values.projectId}
              onChange={(e: SelectChangeEvent<string>) => {
                const value = e.target.value;
                formik.setFieldValue('projectId', value);
              }}
              error={formik.touched.projectId && Boolean(formik.errors.projectId)}
              fullWidth>
              {emailQuestionnaireDetails.projects.sort((a, b) => a.summary.localeCompare(b.summary)).map((project, index) => (
                <MenuItem key={index}
                  value={project.id}>{project.summary}</MenuItem>
              ))}
            </Select>
            {formik.touched.projectId && formik.errors.projectId &&
              <FormHelperText sx={{ color: "#bf3333", marginLeft: "16px !important" }}>
                {formik.errors.projectId ? <div>{formik.errors.projectId as string}</div> : null}
              </FormHelperText>
            }
          </FormControl>
        </Stack>}
        {(isDemonstrationPage || isTest) && <Stack display='flex' alignItems={isMobileModeSm ? 'flex-start' : 'center'} flexDirection={isMobileModeSm ? 'column' : 'row'} justifyContent='start' sx={{ mt: 2, mb: includeProjects ? 0 : 4 }}>
          <Typography variant='subtitle1' sx={{ color: 'text.primary', width: isMobileModeSm ? '100%' : '50%', minWidth: '400px' }}>Location of work</Typography>
          <FormControl fullWidth variant='outlined'>
            <Select
              size='small'
              disabled
              id='locationId' name='locationId'>
              <MenuItem>
              </MenuItem>
            </Select>
          </FormControl>
        </Stack>}
        {(isDemonstrationPage || isTest) && includeProjects && <Stack display='flex' alignItems={isMobileModeSm ? 'flex-start' : 'center'} flexDirection={isMobileModeSm ? 'column' : 'row'} justifyContent='start' sx={{ mt: 2, mb: 4 }}>
          <Typography variant='subtitle1' sx={{ color: 'text.primary', width: isMobileModeSm ? '100%' : '50%', minWidth: '400px' }}>Project</Typography>
          <FormControl fullWidth variant='outlined'>
            <Select
              size='small'
              disabled
              id='projectId' name='projectId'>
              <MenuItem>
              </MenuItem>
            </Select>
          </FormControl>
        </Stack>}
      </Box>
    )
  }